import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormGroup } from '@angular/forms';
import { ModalData } from '../../model/modal-data.model';
import { OlxCategoryAttribute, OlxPrice } from '../../modules/crm/power-olx-v2/interfaces/power-olx-v2.interface';
import * as _ from 'lodash';
import { OlxPricePayload, PriceForm } from '../../components/price-editor/price-editor.interface';
import { ChangeOlxPriceData } from './change-olx-price.interface';

@Component({
  templateUrl: './change-olx-price.component.html',
  styleUrls: ['./change-olx-price.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChangeOlxPriceComponent {
  protected priceForm!: FormGroup<PriceForm>;
  protected price!: OlxPrice;
  protected priceAttribute?: OlxCategoryAttribute;

  constructor(
    private readonly dialogRef: MatDialogRef<ChangeOlxPriceComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly data: ModalData<ChangeOlxPriceData>,
  ) {
    this.price = data.data?.price || {};
    this.priceAttribute = data.data?.price_attribute;
  }

  protected onFormReady(form: FormGroup<PriceForm>) {
    this.priceForm = form;
  }

  protected onSave() {
    if (this.priceForm.invalid) {
      this.priceForm.markAllAsTouched();
      return;
    }

    const formValue: OlxPricePayload = this.priceForm.getRawValue();

    if (_.isEqual(this.price, formValue)) {
      this.onCancel();
      return;
    }

    this.dialogRef.close(formValue);
  }

  protected onCancel() {
    this.dialogRef.close();
  }
}
